export function iframeForm(config, Alpine) {
  return {
    init() {
      const iframeWrapper = this.$el.querySelector("iframe");
      const formID = iframeWrapper.dataset.id;

      // console.log(iframeWrapper, "##########################");
      window.addEventListener(
        "message",
        (event) => {
          if (event.data && typeof event.data === "object" && event.data.id && event.data.id === "cec-reso") {
            if (formID !== event.data.message || event.data.message === "next page" || event.data.message === "prev page") {
              // console.log(event.data);

              // console.log(event.data.message);
              const iframeWrapperSection = iframeWrapper.closest("section");
              const offset = iframeWrapperSection.offsetTop - document.querySelector(".js-bottom-header").offsetHeight;
              // console.log(iframeWrapperSection.offsetTop, offset);
              // console.log(iframeWrapperSection.offsetTop - offset);
              window.scrollTo({
                top: offset,
                left: 100,
                behavior: "smooth"
              });
            }
          }
        },
        false
      );
    }
  };
}
